export enum AccountIdTypes {
    RNC = 'RNC',
    CIP = 'CIP',
    PAS = 'PAS'
};
